// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__2PDQx","img":"Header_img__qVwVh","_001":"Header__001__1gecO","_005":"Header__005__IBLJ8","_010":"Header__010__1zApD"};